import { useDispatch } from 'react-redux';
import { selectZipcode } from '../redux/carDuck';
import { useHistory } from 'react-router-dom';
import Input from '../components/Input';
import Typography from '../components/Typography';
import Button from '../components/Button';
import { useForm } from '../hooks/useForm';
import validate from '../helpers/validateFormZipcode';

const initialForm = {
  zipcode: ''
};

export const SixthStep = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSelectZipcode = () => {
    dispatch(selectZipcode(form.zipcode));

    history.push('/datos-personales');
  };

  const { form, errors, validFields, handleChange, handleKeyUp, handleSubmit } = useForm(
    initialForm,
    validate,
    handleSelectZipcode
  );

  return (
    <>
      <Typography text='Ingresá tu código postal' />
      <form onSubmit={handleSubmit} autoComplete='off'>
        <Input
          name='zipcode'
          type='tel'
          label='Código Postal'
          value={form.zipcode}
          placeholder={errors.zipcode && 'Ej. 1122'}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
          error={errors.zipcode}
          valid={validFields.zipcode}
          inputProps={{
            maxLength: 4
          }}
        />
        <Button text='Continuar' type='submit' color='secondary' />
      </form>
    </>
  );
};
